// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DebitCardInfoResponseModel {
    static getAttributeTypeMap() {
        return DebitCardInfoResponseModel.attributeTypeMap;
    }
}
DebitCardInfoResponseModel.discriminator = undefined;
DebitCardInfoResponseModel.attributeTypeMap = [
    {
        "name": "accountNumber",
        "baseName": "accountNumber",
        "type": "string"
    },
    {
        "name": "vmcNumber",
        "baseName": "vmcNumber",
        "type": "string"
    },
    {
        "name": "last4",
        "baseName": "last4",
        "type": "string"
    },
    {
        "name": "debitCardMapStatus",
        "baseName": "debitCardMapStatus",
        "type": "DebitCardMapStatus"
    },
    {
        "name": "thirdPartyProcessorType",
        "baseName": "thirdPartyProcessorType",
        "type": "ProcessorType"
    },
    {
        "name": "thirdPartyCardStatus",
        "baseName": "thirdPartyCardStatus",
        "type": "string"
    },
    {
        "name": "thirdPartyCardStatusDescription",
        "baseName": "thirdPartyCardStatusDescription",
        "type": "string"
    },
    {
        "name": "effectiveDate",
        "baseName": "effectiveDate",
        "type": "Date"
    },
    {
        "name": "expirationDate",
        "baseName": "expirationDate",
        "type": "Date"
    },
    {
        "name": "balance",
        "baseName": "balance",
        "type": "number"
    },
    {
        "name": "tcMemberNumber",
        "baseName": "tcMemberNumber",
        "type": "string"
    },
    {
        "name": "vmcNumberOfUses",
        "baseName": "vmcNumberOfUses",
        "type": "number"
    },
    {
        "name": "vmcCvc",
        "baseName": "vmcCvc",
        "type": "string"
    },
    {
        "name": "vmcDollarAmount",
        "baseName": "vmcDollarAmount",
        "type": "number"
    },
    {
        "name": "vmcUsageRegion",
        "baseName": "vmcUsageRegion",
        "type": "DebitCardVmcUsageRegion"
    },
    {
        "name": "vmcExactMatch",
        "baseName": "vmcExactMatch",
        "type": "boolean"
    },
    {
        "name": "vmcUsedCount",
        "baseName": "vmcUsedCount",
        "type": "number"
    },
    {
        "name": "vmcMcmgs",
        "baseName": "vmcMcmgs",
        "type": "Array<string>"
    },
    {
        "name": "vmcValidThroughDate",
        "baseName": "vmcValidThroughDate",
        "type": "Date"
    }
];
//# sourceMappingURL=debitCardInfoResponseModel.js.map